import React, { useState, useReducer, useEffect, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Data from '../Autocertificazioni/data/output';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import FirmaAutocertificazione from './componenti/FirmaAutocert';
import swal from 'sweetalert';

import Cert01 from './tipologieCertificazioni/data_e_luogo_di_nascita';
import Cert02 from './tipologieCertificazioni/residenza';
import Cert03 from './tipologieCertificazioni/cittadinanza';
import Cert04 from './tipologieCertificazioni/stato_civile';
import Cert05 from './tipologieCertificazioni/stato_di_famiglia';
import Cert06 from './tipologieCertificazioni/titolo_di_studio';
import Cert07 from './tipologieCertificazioni/situazione_reddituale';
import Cert08 from './tipologieCertificazioni/possesso_e_numero_della_partita_iva';
import Cert09 from './tipologieCertificazioni/stato_di_disoccupazione';
import Cert10 from './tipologieCertificazioni/stato_di_qualità_di_pensionato';
import Cert11 from './tipologieCertificazioni/stato_di_qualità_di_studente';
import Cert12 from './tipologieCertificazioni/stato_di_qualità_di_casalingo_a';
import Cert13 from './tipologieCertificazioni/stato_di_morte';

import Input from './componenti/input/Simple';
import InputProv from './componenti/input/Provincia';
import InputDate from './componenti/input/Date';

import './styles.css';

const AutocertificazioniCorpus = ({autocertificazioniID, isDesktopOrLaptop, isSmallScreen}) => {
  var today = new Date();
  const dataOggi = today.getFullYear() + "-"+ parseInt(today.getMonth()+1) +"-"+ today.getDate();
  const dataOggiFormat = formatDate(dataOggi)

  // stati SESSO
  const [sesso, setSesso] = useState('');
  const [text_il, setText_il] = useState('Il/La');
  const [text_nato, setText_nato] = useState('nato/a');
  const [text_sottoscritto, setText_sottoscritto] = useState('sottoscritto/a');
  const [text_cittadino, setText_cittadino] = useState('cittadino/a');
  const [text_single, setText_single] = useState('celibe/nubile');
  const [text_disoccupato, setText_disoccupato] = useState('disoccupato/a');
  const [text_pensionato, setText_pensionato] = useState('pensionato/a');
  const [text_casalingo, setText_casalingo] = useState('casalingo/a');

  // stati OUTPUT RENDERING
	const [anteprima, setAnteprima] = useState(false);
  const [stampa, setStampa] = useState(false);

  // stati FIRMA
  const [imageURL, setImageURL] = useState(false); // create a state that will contain our image url
  const [cancellaFirma, setCancellaFirma] = useState(false);
  const sigCanvas = useRef({});

  // stati FORM
  const [inputValues, setInputValues] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      nomeCognome: 
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Nome Cognome' }
      ,
      citNascita: 
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Città' }
      ,
      annoNascita: 
        { valore: '', stile: 'text_short', type: 'date', placeholder: '...' }
      ,
      provNascita:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      citResidenza: 
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Città' }
      ,
      provResidenza: 
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      viaResidenza: 
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'via/piazza' }
      ,
      nResidenza:
        { valore: '', stile: 'text_very_short', type: 'number', placeholder: '10' }
      ,
      dicCitNascita :
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Città' }
      ,
      dicProvNascita:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      dataNascita:
        { valore: '', stile: 'text_short', type: 'date', placeholder: '...' }
      ,
      luogoRichiesta:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Luogo di richiesta' }
      ,
      dicCitResidenza:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Città' }
      ,
      dicProvResidenza:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      dicViaResidenza:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'via/piazza' }
      ,
      dicNResidenza:
        { valore: '', stile: 'text_very_short', type: 'number', placeholder: '10' }
      ,
      dicAnnoResidenza:
        { valore: '', stile: 'text_very_short', type: 'number', placeholder: '2000' }
      ,
      dicComune:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Città' }
      ,
      dicProvComune:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      statoCivile:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'specificare condizione stato civile' }
      ,
      nPersone:
        { valore: '', stile: 'text_very_Xshort', type: 'number', placeholder: '3' }
      ,
      statoFamiglia1:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      statoFamiglia2:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      statoFamiglia3:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      statoFamiglia4:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      statoFamiglia5:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      statoFamiglia6:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      statoFamiglia7:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'Cognome Nome - XXXXXXX - Città - gg/mm/aaaa' }
      ,
      titoloStudio:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'nome titolo di studio' }
      ,
      annoScolastico:
        { valore: '', stile: 'text_very_short', type: 'number', placeholder: 'aaaa' }
      ,
      scuola:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Nome istituto' }
      ,
      scuolaCit:
        { valore: '', stile: 'text_short', type: 'text', placeholder: 'Città' }
      ,
      provScuolaCit:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      votazione:
        { valore: '', stile: 'text_short', type: 'number', placeholder: 'voto' }
      ,
      votazione1:
        { valore: '', stile: 'text_short', type: 'number', placeholder: 'massimo punteggio' }
      ,
      durataAnni:
        { valore: '', stile: 'text_very_short', type: 'number', placeholder: '3' }
      ,
      annoReddito:
      { valore: '', stile: 'text_very_short', type: 'number', placeholder: '2021' }
      ,
      totReddito:
        { valore: '', stile: 'text_short', type: 'number', placeholder: '25000' }
      ,
      redditoLettere:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'reddito in lettere' }
      ,
      dittaDenominata:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'nome ditta' }
      ,
      citIva:
        { valore: '', stile: 'text_short', type: 'text', placeholder: 'Città' }
      ,
      provIva:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      viaIva:
      { valore: '', stile: 'text_long', type: 'text', placeholder: 'via/piazza' }
      ,
      ncitIva:
        { valore: '', stile: 'text_very_short', type: 'number', placeholder: '10' }
      ,
      nUffIva:
        { valore: '', stile: 'text_short', type: 'number', placeholder: 'n° P.IVA' }
      ,
      annoDisoccupazione:
        { valore: '', stile: 'text_short', type: 'number', placeholder: '2021' }
      ,
      annoPensionato:
        { valore: '', stile: 'text_short', type: 'number', placeholder: '2021' }
      ,
      catPens:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'categoria pensionamento' }
      ,
      annoCatPens:
        { valore: '', stile: 'text_short', type: 'number', placeholder: '2021' }
      ,
      tipoIstituto:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'scuola/università' }
      ,
      nomeIstituto:
        { valore: '', stile: 'text_very_long', type: 'text', placeholder: 'nome' }
      ,
      citStudente:
        { valore: '', stile: 'text_short', type: 'text', placeholder: 'Città' }
      ,
      provCitStudente:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Prov.' }
      ,
      nomeCognomeDef:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Cognome Nome' }
      ,
      gradoParentelaDef:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'madre/padre/.etc' }
      ,
      citNascitaDef:
        { valore: '', stile: 'text_long', type: 'text', placeholder: 'Città' }
      ,
      provcitNascitaDef:
        { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      annoNascitaDef:
        { valore: '', stile: 'text_short', type: 'date', placeholder: '...' }
      ,
      citMorte:
        { valore: '', stile: 'text_short', type: 'text', placeholder: 'Città' }
      ,
      provMorte:
      { valore: '', stile: 'text_very_short', type: 'text', placeholder: 'Prov.' }
      ,
      annoMorteDef:
        { valore: '', stile: 'text_short', type: 'date', placeholder: '...' }
    }
  );

  // FUNZIONI

  function formatDate(inputData) {
    const dob = new Date(inputData);
  
    const monthNames = [
      'Gennaio', 'Febbraio', 'Marzo',
      'Aprile', 'Maggio', 'Giugno', 'Luglio',
      'Agosto', 'Settembre', 'Ottobre',
      'Novembre', 'Dicembre'
    ];
  
    const day = dob.getDate();
    const monthIndex = dob.getMonth();
    const year = dob.getFullYear();
  
    // return day + ' ' + monthNames[monthIndex] + ' ' + year;
    return `${day} ${monthNames[monthIndex]} ${year}`;
  }

  const handleOnChange = event => {
    const { name, value } = event.target;
    // console.log(name, value, inputValues[name].type, inputValues[name].style)
    try {
      if (inputValues[name].type ==='date') {
        const dataT = formatDate(value)
  
        setInputValues({ 
          ...inputValues,
          [name]: 
            { 
              ...inputValues[name],
              valore: dataT,
              valueCompiled: value,
            } 
          }
        );
  
      }
  
      else {
        setInputValues({ 
          ...inputValues,
          [name]: 
            { 
              ...inputValues[name],
              valore: value,
            } 
          }
        );
      }

    }
    catch(err) {
      console.log(err)
    }

    
  };

  const anteprimaVieW = () => {
    if (sesso==='') {
      swal('Indicare il genere del sottoscrivente per visualizzare l\'anteprima e stampare il certificato.');
    }
    else {
      setAnteprima(true)
    }
  };

  const modificaFun = () => {
    setAnteprima(false)
  };
  
  const scaricaCert = () => {
    setAnteprima(true)
    setStampa(true)
  }

  const clearSig = () => {
    sigCanvas.current.clear();
    setCancellaFirma(false);
  }

  const saveSig = () => {
    setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    setCancellaFirma(true);
  }

  const handleChange_op = e => {
    setSesso(e.target.value);
  };

  // FUNZIONI UPDATE STATI
  useEffect(() => {
    function PrintData() {
      if (stampa) {
        const input = document.getElementById('pagePrint')
        
        html2canvas(input , {
          dpi: 150, // Set to 300 DPI
          scale: 2, // Adjusts your resolution
          }).then((canvas) => {
                var pdf = new jsPDF("pt", "mm", "a4");
                var imgData = canvas.toDataURL('image/jpeg', 1.0);
                pdf.addImage(imgData, 'JPEG', 0, 0, 210,297);  // hxw mm @ (0,0)mm
                pdf.save(`${autocertificazioniID}.pdf`);
            })
        setStampa(false)
      }
    }
    PrintData();

  }, [stampa]);

  useEffect(() => {
    function ImpostaSesso() {
      if (sesso==='donna') {
        setText_il('La');
        setText_nato('nata');
        setText_sottoscritto('sottoscritta');
        setText_cittadino('cittadina');
        setText_single('nubile');
        setText_disoccupato('disoccupata');
        setText_pensionato('pensionata');
        setText_casalingo('casalinga');
      }
      if (sesso==='uomo' || sesso==='altro') {
        setText_il('Il');
        setText_nato('nato');
        setText_sottoscritto('sottoscritto')
        setText_cittadino('cittadino');
        setText_single('celibe');
        setText_disoccupato('disoccupato');
        setText_pensionato('pensionato');
        setText_casalingo('casalingo');
      }
    }
    ImpostaSesso();

  }, [sesso]);

  return (
    <div id='documentoStampa'>
      {Data.map( item => {
        if (autocertificazioniID === item.link) {
          return (
            <div >
              <h1 className='titleCert'>Autocertificazione <span className='titleCertCol'>{item.name}</span></h1>
              <Row style={{justifyContent: 'center'}}>
                <div className={isDesktopOrLaptop ? 'bookDesktop book' : isSmallScreen ? 'bookSmall book' : 'bookMobile book'} >
                  <div id='pagePrint' className="page">
                      <div className="subpage">

                        <div className='titleForm'>
                          <h3 className='h3title'>Dichiarazione sostitutiva della</h3> 
                          <h2 className='h2title'>CERTIFICAZIONE DI {item.name}</h2>
                          <div>(art. 46 del D.P.R. 28 dicembre 2000.n. 445)</div>
                        </div>


                        <div className='lineCert'>
                          {text_il} {text_sottoscritto}
                          <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='nomeCognome'
                          />
                          {text_nato} il
                          <InputDate
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='annoNascita'
                          />
                          a
                          <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='citNascita'
                          />
                          <InputProv
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='provNascita'
                          />
                          residente a
                          <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='citResidenza'
                          />
                          <InputProv
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='provResidenza'
                          />
                          in
                          <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='viaResidenza'
                          />
                          , n°
                          <Input
                            anteprima={anteprima} 
                            inputValues={inputValues}
                            handleOnChange={handleOnChange}
                            inputName='nResidenza'
                          />

                          {(() => {
                            if(item.consapevolezza==='corta') {
                              return(
                                <div className='consapevolezza'>
                                  consapevole delle sanzioni penali, nel caso di dichiarazioni non veritiere, di formazione o uso di
                                  atti falsi, richiamate dall'ari. 76 del D.P.R. 445 del 28 dicembre 2000
                                </div>
                              );
                            }
                            if(item.consapevolezza==='lunga') {
                              return(
                                <div className='consapevolezza'>
                                  consapevole che in caso di dichiarazione mendace, formazione di atti falsi o loro uso, sarà
                                  penalmente responsabile e sarà punito ai sensi della legge penale secondo quanto prescritto dall’art.
                                  76 del D.P.R. 445/2000 e che, inoltre , qualora dal controllo effettuato emerga la non veridicità del
                                  contenuto di taluna delle dichiarazioni rese, decadrà dai benefici conseguenti al
                                  provvedimento eventualmente emanato sulla base della dichiarazione non veritiera (art. 75
                                  D.P.R. 445/2000)
                                </div>
                              );
                            }
                          })()}

                          {(() => {
                            if (item.link === 'data_e_luogo_di_nascita') {
                              return (
                                <Cert01
                                  text_nato= {text_nato}
                                  anteprima= {anteprima}
                                  inputValues= {inputValues}
                                  handleOnChange= {handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'residenza') {
                              return (
                                <Cert02
                                  text_nato= {text_nato}
                                  anteprima= {anteprima}
                                  inputValues= {inputValues}
                                  handleOnChange= {handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'cittadinanza') {
                              return (
                                <Cert03 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_civile') {
                              return (
                                <Cert04 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  text_single={text_single}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_di_famiglia') {
                              return (
                                <Cert05 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'titolo_di_studio') {
                              return (
                                <Cert06 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'situazione_reddituale') {
                              return (
                                <Cert07 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'possesso_e_numero_della_partita_iva') {
                              return (
                                <Cert08 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_di_disoccupazione') {
                              return (
                                <Cert09 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  text_disoccupato={text_disoccupato}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_di_qualità_di_pensionato') {
                              return (
                                <Cert10 
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  text_disoccupato={text_disoccupato}
                                  text_pensionato={text_pensionato}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_di_qualità_di_studente') {
                              return (
                                <Cert11
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  text_disoccupato={text_disoccupato}
                                  text_pensionato={text_pensionato}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_di_qualità_di_casalingo_a') {
                              return (
                                <Cert12
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  text_disoccupato={text_disoccupato}
                                  text_pensionato={text_pensionato}
                                  text_casalingo={text_casalingo}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                            if (item.link === 'stato_di_morte') {
                              return (
                                <Cert13
                                  text_nato={text_nato}
                                  text_cittadino={text_cittadino}
                                  text_disoccupato={text_disoccupato}
                                  text_pensionato={text_pensionato}
                                  text_casalingo={text_casalingo}
                                  anteprima={anteprima}
                                  inputValues={inputValues}
                                  handleOnChange={handleOnChange}
                                  />
                              );
                            }
                          })()}
                        </div>

                        <div className='dataOggi'>
                          
                          <span>
                            <Input
                              anteprima={anteprima} 
                              inputValues={inputValues}
                              handleOnChange={handleOnChange}
                              inputName='luogoRichiesta'
                            />, {dataOggiFormat}
                          </span>
                        </div>

                        <FirmaAutocertificazione
                            anteprima= {anteprima}
                            inputValues= {inputValues}
                            imageURL= {imageURL}
                            sigCanvas= {sigCanvas}
                            cancellaFirma= {cancellaFirma}
                            clearSig= {clearSig}
                            saveSig= {saveSig}
                        />

                        <div className='finishline'>
                            <p>Esente da imposta di bollo ai sensi dell'art. 37 D.P.R. 28 dicembre 2000, n. 455.</p>
                            <p>La firma non va autenticata, né deve necessariamente avvenire alla presenza dell'impiegato dell'Ente che ha richiesto il certificato.</p>
                        </div>

                      </div>    
                  </div>
                </div>
              </Row>
            </div>
          );
        }
      }
      )}
      <div className='boxbottoniCert'>
        <select className='sessoBox' style={anteprima ? {display:'none'} : {display:'unset'}} onChange={handleChange_op}>
          <option value="" selected disabled hidden>Genere del sottoscrivente</option>
          <option value="uomo">Uomo</option>
          <option value="donna">Donna</option>
          <option value="altro">Altro</option>
        </select>
        {(() => {
            if (!anteprima) {
              return (
                <>
                  <button className='bottoniCert' onClick={() => anteprimaVieW()}>Anteprima</button>
                </>
                );
              }
            else {
              return(
                <button className='bottoniCert' onClick={() => modificaFun()}>Modifica</button>
              );
            }
          })()}
          <button className='bottoniCert' onClick={() => scaricaCert()}>Scarica certificato</button>
        </div>
    </div>
    
  );
};

export default AutocertificazioniCorpus;
